import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=68e0cd52&scoped=true"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=68e0cd52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0cd52",
  null
  
)

export default component.exports